<template>
  <!-- 绑定微信，关注公众号弹窗 -->
  <van-popup class="service-popup wx-popup"
  round
  v-model="showWxPopup"
  :style="{ width: '80%' }">
      <i class="notice"></i>
      <div class="tit tac">
        <slot name="tit"></slot>
      </div>
      <div class="cnt tac">
        <p class="tips">
          <slot name="tips"></slot>
        </p>
        <p><img :src="wxCode" alt="" class="wxcode"></p>
        <div class="close" @click="showWxPopup = false"></div>
      </div>
  </van-popup>
</template>
<script>
import Cookies from 'js-cookie'
import { Toast } from 'vant'
import { Dialog } from 'vant'

import { getToken } from '@/utils/auth'
import { header as getHeader, user as getUser } from '@/api/common'
import {erweima2, ajaxCenterInfo } from "@/api/service"

var _t=null;

export default {
  name: "bindWxPopup",
  components: {
    
  },
  data() {
    return {
     member_id:'',
     showWxPopup: false,
      wxCode: 'https://www.yiihuu.com/assets/common/yh/img/index_new/ewm_new.png',
    };
  },
  created() {
    
  },
  mounted() {
    // this.getInitDataFn()
    this.$nextTick(() => {

    })
  },
  computed: {
    isLogin() {
      return getToken()
    },
  },
  watch: {
    
  },
  methods: {
    show(){
      this.showWxPopup=true
      this.getInitDataFn()
    },
    hide(){
      this.showWxPopup = false
      this.clearTimer()
    },
    getInitDataFn(){
      if (this.isLogin) {
        this.getUser()
      }
    },
    async getUser() {
      let res = await getUser()
      let { member } = res.data
      let { bind_wx, member_id } = member
      if (!bind_wx) {//未绑定微信
        this.member_id= member_id
        this.getQrCode()
      }
    },
    async getQrCode(){
      let rand = Math.floor(Math.random() * (999 - 100 + 1)) + 100 //生成一个介于100和999之间的随机整数
      let wxloginkey = `${rand}mid${this.member_id}`
      let params = {
        'wxloginkey': wxloginkey
      }

      let res2 = await erweima2(params).catch((err) => {
        console.log(err)
      })
      // console.log(res2)
      this.wxCode = res2

      _t = setInterval(function () {
        let res3 = ajaxCenterInfo(params).then((data) => {
          // console.log(data)
          let error = data.error
          let msg
          if (error == 1) {
            //绑定过提示是否合并
          } else if (error == 2) {
            msg = "绑定成功";
            this.wxCode=this.$options.data().wxCode//绑定微信后，更新为默认为关注公众号二维码
          } else if (error == 5) {
            msg = "该帐号不支持绑定,如有疑问请联系客服";
          } else if (error == 6) {
            mg = "该微信帐号已禁用,如有疑问请联系客服";
          } else if (error == 4) {
            //已绑定过相同的账号类型不能绑定
            msg = "该微信帐号已绑定其他账号,请更换微信帐号"
          } else if (error == 3) {
            msg = "绑定失败，稍后再试";
          }
          msg && Toast(msg)
        }).catch((err) => {
          console.log(err)
        })
      }, 4000);
      setTimeout(()=>{
        //3分钟用户不扫码清掉定时器
        this.clearTimer()
      }, 180000)
    },
    clearTimer(){
      _t && clearInterval(_t);
    }
  }
};
</script>
<style src="@/assets/css/service.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
.wx-popup{
  padding: 0 40px 24px;
  border-radius: 16px;
  overflow: visible;
  .notice{
    display: block;
    width: 150px;
    height: 158px;
    margin: -20px auto 0;
    background: url("~@/assets/images/service/refund/notice.png") 50% 50%/100% 100% no-repeat;
  }
  .tit{
    margin-top: 16px;
    font-size: 36px;
  }
  .cnt{
    .tips{
      margin-top: 16px;
      color: #777;
      font-size: 28px;
    }
    .wxcode{
      width: 408px;
      height: 408px;
      margin-top: 16px;
      background-color: #d9d9d9;
    }
    .close{
      width: 64px;
      height: 64px;
      background: url("~@/assets/images/service/refund/close.png") 50% 50%/100% 100% no-repeat;
      position: absolute;
      left: 0;
      right: 0;
      top: 100%;
      margin: 46px auto 0;
    }
  }
}
</style>
